import React from 'react'
// @ts-ignore no types
import { Text } from '@adc/ui-adc'
import type { Maybe } from '@adc/sdk/types'
import { usePropertyContext } from 'common/context/property'
import { useListingContext } from 'common/context/listing'
import AuctionDetailsTemplate, {
  SAVED_MESSAGE,
  UNSAVED_MESSAGE,
  SavePropertyButton,
} from '../template'

const detailContent = (isSaved: Maybe<boolean> | undefined) => [
  {
    label: (
      <Text color='gray' data-elm-id='coming_soon_message'>
        {isSaved ? (
          <div>{SAVED_MESSAGE}</div>
        ) : (
          <div>
            <div className='u-mb-2'>{UNSAVED_MESSAGE}</div>
            <div>
              Detailed dates & times
              <br />
              coming soon!
            </div>
          </div>
        )}
      </Text>
    ),
  },
]

interface ComingSoonProps {
  pushAuthQueueItem: (item: any) => void
  toggleAuthModal: () => void
}

const ComingSoon = ({
  pushAuthQueueItem,
  toggleAuthModal,
}: ComingSoonProps) => {
  const { listing } = useListingContext()
  const { property, propertyActions } = usePropertyContext()

  const isSaved = property.is_currently_saved
  return (
    <AuctionDetailsTemplate
      title=''
      primaryButton={
        <SavePropertyButton
          listing={listing}
          property={property}
          isSaved={isSaved}
          actions={propertyActions}
          pushAuthQueueItem={pushAuthQueueItem}
          toggleAuthModal={toggleAuthModal}
        />
      }
      detailContent={detailContent(isSaved)}
    />
  )
}

export default ComingSoon
